import React from 'react';
import styled from 'styled-components';
import { ThemeProvider } from '@mui/material/styles';

import theme from './common/theme';

import PdfViewer from './pdf-magazine/PdfViewer';

const App = () => (
  <ThemeProvider theme={theme}>
    <StyledWrapper>
      <PdfViewer />
    </StyledWrapper>
  </ThemeProvider>
);

const StyledWrapper = styled.div`
  height: 100%;

  @media print {
    margin-top: 0;
    button {
      display: none !important;
    }
  }
`;

export default App;
